import axios from 'axios';
import TopBar from 'components/Layout/TopBar';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useNavigate } from 'react-router';
import { ClipLoader } from 'react-spinners';
import useAuthz from '../../hooks/useAuthz';
import { URL_API } from '../../utils/globalConfig';
import MyForm from '../../components/Layout/MyForm';
import MyButton from '../../components/Layout/MyButton';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import { PARAMETER, PARAMETER_VALUE } from '../../constants/enum';

const EditParameter = (props) => {
  const parameter_id = new URLSearchParams(location.search).get('id');
  const [isLoading, setIsLoading] = useState(true);
  const [formIsValid, setFormValid] = useState(true);
  const navigate = useNavigate();
  const alert = useAlert();
  const [authz, user, profil] = useAuthz();
  const [parameter, setParameter] = useState({
    id: null,
    key: null,
    description: null,
    value: null,
  });
  const [formParametre, setFormParametre] = useState([
    {
      id: 'key',
      name: 'key',
      label: 'CLEF',
      type: 'text',
      required: false,
      readOnly: true,
      style: { width: '100%', margin: '20px' },
    }, {
      id: 'description',
      name: 'description',
      label: 'DESCRIPTION',
      type: 'text',
      required: true,
      readOnly: false,
      style: { width: '100%', margin: '20px' },
    }, {
      id: 'value',
      name: 'value',
      label: 'VALEUR',
      type: 'text',
      required: true,
      readOnly: false,
      style: { width: '100%', margin: '20px' },
    }]);

  //#region useEffect

  useEffect(() => {
    if (profil.profil === 1) {
      document.title = 'TE - Editer un paramètre';
      fetchLoadParameter();
      setIsLoading(false);
    } else {
      alert.error('Vous n\'êtes pas autorisé à accéder à ce module');
      navigate('/');
    }
  }, []);

  useEffect(() => {
    if (!isLoading) {
      handleDynamicColumns();
    }
  }, [parameter.id]);

  //#endregion

  //#region Fonctions

  const fetchLoadParameter = () => {
    axios({ method: 'get', url: `${URL_API}/parameters/get-by-id?id=${parameter_id}` })
      .then((response) => {
        if (response.data.value.startsWith('[') && response.data.value.endsWith(']')) {
          response.data.value = JSON.parse(response.data.value);
        }
        setParameter(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        alert.removeAll();
        alert.error(error);
      });
  };

  const onCellEdit = (form, rowIndex, cellIndex, editedValue) => {
    if (form.id === 'costCenterTable') {
      let formData = parameter.value;
      let row = formData[rowIndex];
      let cell = cellIndex === 0 ? 'label' : 'value';
      row[cell] = editedValue;
      formData[rowIndex] = row;
      setParameter({ ...parameter, value: formData });
      return;
    }

    if (editedValue === '') return;
    let formData = parameter.value;

    let row = formData[rowIndex];
    let cell;

    switch (cellIndex) {
      case 1:
        cell = '1';
        break;
      case 2:
        cell = '<10';
        break;
      case 3:
        cell = '<20';
        break;
      case 4:
        cell = '20 et +';
        break;
      default:
        break;
    }

    row[cell] = editedValue;
    formData[rowIndex] = row;
    setParameter({ ...parameter, value: formData });
  };

  const handleDynamicColumns = () => {
    switch (parameter.key) {
      case 'LEGAL_NOTICE':
      case 'PARTICULAR_NOTICE':
        let entriesLegal = [];

        entriesLegal.push({
          id: 'value',
          name: 'value',
          label: 'VALEUR',
          type: 'editor',
          value: parameter.value,
          required: true,
        });

        formParametre.pop();
        setFormParametre([...formParametre, ...entriesLegal]);
        break;

      case 'ALERT_CHANGE':
        let entries = [];
        entries.push({
          id: 'value',
          name: 'value',
          label: 'ACTION',
          type: 'select',
          value: parameter.value,
          options: [
            { id: 'engage', label: PARAMETER_VALUE.ALERT_CHANGE.ENGAGE },
            { id: 'devis_validated', label: PARAMETER_VALUE.ALERT_CHANGE.DEVIS_VALIDATED },
            { id: 'document_uploaded', label: PARAMETER_VALUE.ALERT_CHANGE.DOCUMENT_UPLOADED },
            { id: 'planning_filled', label: PARAMETER_VALUE.ALERT_CHANGE.PLANNING_FILLED }
          ],
          disabled: false,
          displayLabel: true,
          labelClass: 'select-label-black',
          multiple: true,
          disableClass: true,
          formControlStyle: { width: '100%'},
          required: true
        });

        formParametre.pop();
        setFormParametre([...formParametre, ...entries]);
        break;
      case 'COST_CENTER':
      case 'CODE_LOC':
        let entriesCostCode = [];
        let valueCostCode = parameter.value;

        for (let item of valueCostCode) {
          let entry = [
            { label: item.label, align: 'center', editable: true, style: {} },
            { label: item.value, align: 'center', editable: true, style: {} },
          ];

          entriesCostCode.push(entry);
        }

        let formTableCostCenter = {
          id: 'costCenterTable',
          type: 'table',
          columns: [
            { id: 'label', label: 'Description', align: 'center', style: { color: 'white', fontWeight: 'bold'}},
            { id: 'value', label: 'Valeur', align: 'center', style: { color: 'white', fontWeight: 'bold'}},
          ],
          rows: entriesCostCode,
        }

        formParametre.pop();
        setFormParametre([...formParametre, formTableCostCenter]);
        break;

      case 'COST':
        let entriesCost = [];
        let value = parameter.value;

        for (let item of value) {
          let entry = [
            { label: item.km, align: 'center', editable: false, style: {} },
            { label: item['1'], align: 'center', editable: true, style: {} },
            { label: item['<10'], align: 'center', editable: true, style: {} },
            { label: item['<20'], align: 'center', editable: true, style: {} },
            { label: item['20 et +'], align: 'center', editable: true, style: {} },
          ];

          entriesCost.push(entry);
        }

        let formTable = {
          id: 'costTable',
          type: 'table',
          columns: [
            { id: 'head', label: 'KM \\ Nb passages', align: 'center', style: { fontWeight: 'bold'}},
            { id: '1', label: '1', align: 'center', style: { fontWeight: 'bold'}},
            { id: '<10', label: '<10', align: 'center', style: { fontWeight: 'bold'}},
            { id: '<20', label: '<20', align: 'center', style: { fontWeight: 'bold'}},
            { id: '20 et +', label: '20 et +', align: 'center', style: { fontWeight: 'bold'}},
          ],
          rows: entriesCost,
        };

        formParametre.pop();
        setFormParametre([...formParametre, formTable]);
        break;
      default:
        break;
    }
  };

  const handleChangeValue = (event) => {
    setParameter({ ...parameter, [event.target.name]: event.target.value });
    let formData = [...formParametre];
    formData.map((formDatum) => {
      if (formDatum.id === event.target.name) {
        formDatum.value = event.target.value;
      }
    });
    setFormParametre(formData);
  };
  const handleCancel = () => {
    navigate('/panneau-administration/parametrage');
  };
  const handleValid = () => {
    setFormValid(true);
    if (parameter.description === null || parameter.value === null) setFormValid(false);

    if (!formIsValid) alert.error('Vous devez renseigner les champs requis avant de continuer'); else {
      editParameter();
    }
  };
  const editParameter = () => {

    if (parameter.key === PARAMETER.NAT_CONVOI) {
      parameter.value = parameter.value.split(',');
    }
    if (Array.isArray(parameter.value)) {
      parameter.value = JSON.stringify(parameter.value);
    }

    axios({
      method: 'post',
      url: `${URL_API}/parameters/update`,
      data: parameter,
      params: { userAction: user.user_id },
    })
      .then(() => {
        alert.removeAll();
        alert.success('L\'édition du paramètre a bien été effecutée ');
        navigate('/panneau-administration/parametrage');
      })
      .catch((error) => {
        alert.removeAll();
        alert.error(error.response.data.message);
      });
  };

  //#endregion

  return (<div style={{ height: '100%' }}>
    <TopBar title='Editer un paramètre' className='topbar-contenu' color={props.params.color} buttons={null} />

    <div className='row' style={{ alignItems: isLoading ? 'center' : '', height: 'calc(100% - 50px)' }}>
      <ClipLoader color='#0094ca' loading={isLoading} size={75}
                  css={'display: flex; margin: 25px;justify-content: center;'} />

      {!isLoading && (<div className='form-content-center' style={{ minWidth: 750 }}>
        <MyForm data={parameter} variant={'outlined'} setData={setParameter} form={formParametre}
                onChange={handleChangeValue} onCellEdit={onCellEdit} />

        {parameter.key === 'COST' && (
          <p>Où K = (Nb de passages Aller x Nb de véhicules Aller x Kilométrage Aller x Coût du KM)
   + (Nb de passages Retour x Nb de véhicules Retour x Kilométrage Retour x Coût du KM)</p>
        )}
        <div className='row' style={{ width: '100%', margin: '20px' }}>
          <MyButton onClick={handleCancel} style={'buttonDefault'} label={'Annuler'} icon={faXmark} />
          <MyButton onClick={handleValid} style={'buttonValidation'} label={'Valider'} icon={faCheck} />
        </div>
      </div>)}
    </div>
  </div>);
};

export default EditParameter;